import { CustomUrl, LocaleIsoCode } from "@/types";
import { ISO_TO_LOCALE } from "./localization";

export const getHrefFromCustomUrlPlugin = (data: CustomUrl): string => {
  let url;

  if (typeof data === "string") {
    url = data;
  } else if (typeof data === "object") {
    const locale = data.value?.data?.locale
      ? `/${ISO_TO_LOCALE[data.value?.data.locale as LocaleIsoCode]}`
      : "";
    url = locale + data.value?.data?.url;
  }

  return url ?? "/";
};
